import type { ActivatedRoute, Router } from '@angular/router';

export class RoutingUtilService {
  public static removeQueryParams(router: Router, activatedRoute: ActivatedRoute, paramNames: string[]): void {
    const currentParams = { ...activatedRoute.snapshot.queryParams };

    paramNames.forEach((paramName) => delete currentParams[paramName]);

    router.navigate([], {
      relativeTo: activatedRoute,
      queryParams: currentParams,
    });
  }
}
